var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"landing-wrapper"},[_c('TopBar'),_c('LandingHeader'),_c('main',{staticClass:"landing-content"},[_c('router-view')],1),_c('LandingFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }